export default "__VITE_ASSET__N4dYj4EI__"